
import Axios from "@/global/AxiosCall";
import {url} from '@/configs/apiUrl'

/**
 * Device Type API
 * {
 *     code: <integer>,
 *     message: <string>,
 *     data: <object>
 * }
 */
export default class DeviceTypeAPI {

    /**
     * call API to show device type list
     * @returns {Promise<unknown>}
     * @constructor
     */
    static ListDeviceTypeForOptions(){
        return new Promise(((resolve, reject) => {
            Axios.Get(url.svd.device_type.selection).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }, (err) => {
                reject(err)
            })
        }))
    }
}